import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
    @Input() enabled: boolean;

    constructor() {
        this.enabled = false;
    }


}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/loading/loading.component.ts